import React from 'react';
import CustomButton from './CustomButton';
import './theme.css';

class PluginItem extends React.Component{
  /*constructor(props)
  {
    super(props);
  }*/

  render(){
    let firstPicSize = '50%';
    if(!this.props.Img2)
      firstPicSize = '100%';
    return(
      <div className="keret szovegdoboz">
        {this.props.Name}<br/>
        {this.props.Desc}<br/>
        <br/>
        <div className="keret szovegdoboz" style={{float: 'left', width: '40%'}}>
          {this.props.Img1 &&
            <img src={this.props.Img1} alt="image" style={{width: firstPicSize}} />
          }
          {this.props.Img2 &&
            <img src={this.props.Img2} alt="image" style={{width: '50%'}} />
          }
        </div>
        <div className="keret szovegdoboz" style={{float: 'right', width: '40%'}}>
           <p><b>Download:</b></p>
           <p>.zip file containing 32 and 64 bit DLLs bundled with source code and how-to.</p>
             <CustomButton newTab url={this.props.Url} icon='file_download' tooltip="Download"/>
          <p>last update: {this.props.LastUpdate}</p>
        </div>
      </div>
    );
  }
}

export default PluginItem;



// WEBPACK FOOTER //
// ./src/Component/PluginItem.js